import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/faq';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-paper px-4 py-16 sm:py-20" data-id="element-153" data-mp="2z3h1e6a4p5i0">
      <div className="mx-auto max-w-3xl" data-id="element-154" data-mp="3msjhh9p46qae">
        <SectionHeading title="Frequently asked questions" data-id="element-155" data-mp="3mtl48bfht17y" />
        <ul className="mt-10 space-y-3" data-id="element-156" data-mp="3rs5w9nklcelb">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-cream" data-id="element-157" data-mp="3d2q90hk9qrad" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-base font-bold text-ink" data-id="element-158" data-mp="3i0rz3mg43qvc">
                  {f.q}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-forest transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-159" data-mp="20om730qujftj" />
                </button>
                <AnimatePresence initial={false} data-id="element-160" data-mp="25pjovc7y27ui">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-161" data-mp="2jgoowff8525d">
                      <p className="px-5 pb-5 text-base leading-relaxed text-muted" data-id="element-162" data-mp="2og1cx3hu0f9j">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
        <div className="mt-10" data-id="element-163" data-mp="u3urzcz4yk41">
          <CTAButton label="Yes! My questions are answered — I'm in" note="7-Day Guarantee · Lifetime access" data-id="element-164" data-mp="1jqfa8d3ks3g9" />
        </div>
      </div>
    </section>;
}